
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// material
import { useTheme } from '@mui/material/styles';
import {
    Container,
    Box,
} from '@mui/material';
import { Switch } from 'src/@/components/ui/switch';

import { useSnackbar } from 'notistack';
import useAuth from 'src/hooks/useAuth';

import { HeaderPageComponentConfig } from 'src/components/_dashboard/configuracoes';

// zui
import { Button } from 'src/@/components/ui/button';
import { RowInput } from 'src/components/forms/RowInput';
import { Input } from 'src/@/components/ui/input';
import { Textarea } from 'src/@/components/ui/textarea';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import actionListaIntegracoesByCliente from 'src/actions/clientes/actionListaIntegracoesByCliente';
import actionEditarIntegracao from 'src/actions/clientes/actionEditarIntegracao';
import GoogleLogin from './components/GoogleLogin';
import { GoogleOAuthProvider } from '@react-oauth/google';
import v2_actionCredenciais from 'src/actions/v2/cliente/v2_actionCredenciais';


export default function Google() {
    const { cliente } = useAuth()
    const navigate = useNavigate();
    const [id, setId] = useState(null);
    const [chatGptStatus, setChatGptStatus] = useState(false)
    const [instrucaoChatgpt, setInstrucaoChatgpt] = useState('');
    const enqueueSnackbar = useSnackbar();
    const [googleLogin, setGoogleLogin] = useState(null)

    async function getList() {
        try {
            let querys = `?source=google`
            const response = await v2_actionCredenciais(cliente._id, querys);
            console.log('response', response)
            setGoogleLogin(response.data.data)
        } catch (error) {
            console.log('error', error)
        }
    }

    useEffect(() => {
        getList()

    }, [])

    return (
        <Box>


            <Container sx={{ mt: 4 }} maxWidth="lg">
                <HeaderPageComponentConfig
                    backAction={() => navigate('/dashboard/configuracoes/integracoes')}
                    titulo="Google"
                    descricao={'Gerencie as integrações com o Google'}
                />

                <div className='flex gap-6 flex-col w-1/3 mt-2'>

                    <GoogleOAuthProvider clientId="794991093312-1i2l85tqno28ubs82c7qhcbleptpui8h.apps.googleusercontent.com">

                        <GoogleLogin 
                        clienteId={cliente._id}
                        onLoginSuccess={() => getList()}
                        data={googleLogin}
                        onCallback={() => getList()}
                        />

                    </GoogleOAuthProvider>

                </div>

            </Container>

        </Box>
    );
}
